import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { DataStorageService } from '../../services/data-storage.service';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'app-sent-wishlist-dialog',
    templateUrl: './sent-wishlist-dialog.html'
})
export class SentWishlistDialogComponent {

    public isCassettiera: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<SentWishlistDialogComponent>,
        private router: Router,
        private dataStorageService: DataStorageService,
        public loc: LocalizationService,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit() {

        this.isCassettiera = this.dataStorageService.getConfiguration().isCassettiera;
    }


    closeDialog(): void {
        this.dialogRef.close();
    }

    goToWhereToBuy() {
        this.router.navigate(['where-to-buy']);
        this.dialogRef.close();
        // [routerLink]="['where-to-buy']"
    }

    backToWishList() {

        window.parent.postMessage('Close WhereToBuy', '*');
        // window.location.replace(environment.backToWishListUrl);
    }

}



// WEBPACK FOOTER //
// ./src/app/dialogs/sent-wishlist-dialog/sent-wishlist-dialog.ts